module.exports = {
  getCarouselScrollPositions() {
    const carousels = document.querySelectorAll('.cui-c-compound');

    if (!carousels.length) {
      return {};
    }

    const carouselScrollPositions = {};

    carousels.forEach(carousel => {
      const bhc = carousel.attributes['data-bhc'];
      const carouselScrollContainer = carousel.querySelector(
        '.cui-content.carousel-content'
      );

      if (!bhc || !carouselScrollContainer) {
        return;
      }

      carouselScrollPositions[bhc.value] = carouselScrollContainer.scrollLeft;
    });

    return carouselScrollPositions;
  },
  restoreCarouselScrollPositions(carouselScrollPositions) {
    for (const key in carouselScrollPositions) {
      const carousel = document.querySelector(
        `.cui-c-compound[data-bhc="${key}"]`
      );

      if (carousel) {
        const carouselScrollContainer = carousel.querySelector(
          '.cui-content.carousel-content'
        );
        carouselScrollContainer.scrollLeft = carouselScrollPositions[key];
      }
    }
  },
};
